import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { useClientLogContext } from 'src/contexts/ClientLogContext';
import { tryInvokeApi } from 'src/utils/tryExecuteUtils';
import { BulkEditSaleClient, SaleQuery } from 'src/WebApiController';

export const useBulkUpdateSaleBarcodesPreviewQuery = (
  filterQueryWithEventIds: SaleQuery
) => {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError } = useClientLogContext();
  return useQuery({
    queryKey: [
      'BulkEditSaleClient.bulkUpdateBarcodesPreview',
      activeAccountWebClientConfig.activeAccountId,
      filterQueryWithEventIds,
    ],
    queryFn: () => {
      if (activeAccountWebClientConfig.activeAccountId == null) {
        return null;
      }
      return tryInvokeApi(
        () => {
          return new BulkEditSaleClient(
            activeAccountWebClientConfig
          ).bulkUpdateBarcodesPreview(filterQueryWithEventIds);
        },
        (error) => {
          trackError('BulkEditSaleClient.bulkUpdateBarcodesPreview', error);
        }
      );
    },

    enabled: activeAccountWebClientConfig.activeAccountId != null,
    refetchOnWindowFocus: false,
  });
};
